/**
 * Retrieve the SX to style the <label> element which implicitly wraps a checkbox
 *
 * @param isDisabled whether or not the label should render in the disabled state
 * @param variant the visual variant of the checkbox
 * @param isSelected whether or not the label should render in the selected state
 */
export var getCheckboxLabelSx = function (variant, isDisabled, isSelected) {
    return {
        color: isDisabled ? 'gray-40' : 'black',
        border: variant === 'outlined' ? '1px solid' : 'none',
        borderColor: isSelected
            ? 'primary'
            : isDisabled
                ? 'gray-40'
                : 'gray-20',
        borderRadius: 2,
        paddingY: variant === 'outlined' ? 2 : undefined,
        paddingLeft: variant === 'outlined' ? 1 : undefined,
        paddingRight: variant === 'outlined' ? 2 : undefined,
        lineHeight: 'normal',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        userSelect: 'none',
        display: 'flex',
        width: 'fit-content',
        alignItems: 'center',
        mt: variant === 'group' ? 2 : undefined,
    };
};
/**
 * The SX styles for a checkbox <input> element.
 */
export var checkboxInputSx = {
    marginRight: 2,
    fontSize: 1,
    position: 'relative',
    verticalAlign: 'middle',
    bottom: '0.08em',
    cursor: 'pointer',
    accentColor: '#5614eb',
};
